import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-i-my-reservation',
    templateUrl: './i-my-reservation.component.html',
    styleUrls: ['./i-my-reservation.component.sass'],
    standalone: false
})
export class IMyReservationComponent implements OnInit {
  @Input() tip_service : any = {}
  @Input() kilometraje : any = {}
  @Input() taller : any = {}
  @Input ()cityName : any = {}
  @Input() asesor : any = {}
  @Input() date: any = {}
  @Input() time:any ={}
  @Input() LanguageForCountry:any ={}
  @Input() make:any ={}
  @Input() brandUrl:any ={}
  
  constructor(private translate: TranslateService) { 
      
  }
  // datoresv = ChooseServiceComponent.dato

  ngOnInit(): void {
    

  }
}
